// Generated by GitHub Copilot
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { KeyRound, Smartphone, type LucideIcon } from 'lucide-react'
import type { LockReason } from '#core/auth/login-method.ts'
import { startSsoSignIn } from '#core/auth/sso-sign-in.ts'
import { AUTHENTICATOR_APP_SECTION_ID, LINKED_ACCOUNTS_SECTION_ID } from '#components/entities/users/security/security-panel.tsx'
import { MicrosoftRedirectButton } from '#components/entities/users/sso/microsoft/microsoft-redirect-button.tsx'

const LOCK_REASON_ICON_MAP: Record<LockReason, LucideIcon> = {
  mfa: Smartphone,
  sso: KeyRound,
}

/**
 * Explains one reason a company is locked for this login, with the actions that unlock it.
 *
 * @param companySegment The locked company's URL segment, which an SSO sign-in returns to.
 */
export function CompanyLockReason({ reason, companySegment }: { reason: LockReason; companySegment: string }) {
  const { t } = useTranslation('auth')
  const Icon = LOCK_REASON_ICON_MAP[reason]

  return (
    <div className="card text-start">
      <div className="card-body d-flex align-items-start gap-3">
        <Icon size={24} className="text-primary flex-shrink-0" aria-hidden="true" />
        <div className="d-flex flex-column align-items-start gap-2">
          <p className="mb-0">{t(`companyLock.reason.${reason}`)}</p>
          {reason === 'mfa' && (
            <Link to="/settings/security" hash={AUTHENTICATOR_APP_SECTION_ID} className="btn btn-primary btn-sm">
              {t('companyLock.setUpMfa')}
            </Link>
          )}
          {reason === 'sso' && (
            <div className="d-flex flex-wrap align-items-start gap-2">
              <MicrosoftRedirectButton small label={t('sso.signIn')} start={() => startSsoSignIn('microsoft', `/${companySegment}/`)} />
              <Link to="/settings/security" hash={LINKED_ACCOUNTS_SECTION_ID} className="btn btn-outline-secondary btn-sm">
                {t('companyLock.connectMicrosoft')}
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
